module.exports = __webpack_public_path__ + "static/img/zeta_template_04.1cb06ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zeta_template_04.png
// module id = vNJo
// module chunks = 1